import React, { useState } from 'react';
import { Absolute } from '../Absolute/Absolute';
import { Animate } from '../Animate/Animate';
import { Box } from '../Box/Box';
import { Tooltip } from '../Tooltip/Tooltip';
import { NotificationDot, StyledButton } from './FloatingActionButton.styled';
import { TOOLTIP_ALIGNMENT } from './constants';
/**
 * @public
 */
export function FloatingActionButton({
  hasNotification,
  icon,
  tooltip,
  onClick,
  isAbsolutePosition = true,
  toolAlignment = 'center',
  ...props
}) {
  const [isTooltipOpen, setTooltipOpen] = useState(false);
  const Wrapper = isAbsolutePosition ? Absolute : Box;
  function onMouseOver() {
    setTooltipOpen(true);
  }
  function onMouseOut() {
    setTooltipOpen(false);
  }
  return React.createElement(Wrapper, {
    ...props,
    onMouseOver: onMouseOver,
    onMouseOut: onMouseOut
  }, hasNotification && React.createElement(Absolute, {
    top: 0,
    right: 0
  }, React.createElement(Animate, {
    variant: 'pulse'
  }, React.createElement(NotificationDot, {
    borderRadius: 'full',
    color: 'error',
    width: '16px',
    height: '16px'
  }))), isTooltipOpen && React.createElement(Tooltip, {
    color: 'text.base',
    top: true,
    ...TOOLTIP_ALIGNMENT[toolAlignment],
    bottom: '-2px',
    p: 1
  }, React.createElement(Box, {
    width: '110px'
  }, tooltip)), React.createElement(StyledButton, {
    borderRadius: 'full',
    boxShadowSize: 'overlay-md',
    size: 'extraLarge',
    IconLeft: icon,
    onClick: onClick
  }));
}